/*** IMPORTS FROM imports-loader ***/
(function() {

let youtube = require('./youtube');

module.exports = class {

  /**
  * @return {youtube}
  */
  static get YouTube() {
    return youtube;
  }
};

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./src/index.js
// module id = 0
// module chunks = 0